import React from 'react';

const AnimatedBackgroundDirectional = ({ direction = 'diagonal' }) => {
  // Images
  const realImages = [
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/zhuut348_Dia%202025-11-26%2014.39.25.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/xi81q5st_Finder%202025-11-26%2014.39.25.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/7o117wya_Dia%202025-11-26%2014.39.25.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/2gxp9fuh_Dia%202025-11-26%2020.36.52.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/vfh2k398_Finder%202025-11-26%2020.36.52.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/o5tm29qr_Dia%202025-11-26%2020.36.52.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/tzd65iq9_Dia%202025-11-26%2020.36.52.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/7f4hcs9h_Screenshot%202025-11-26%20at%202.21.59%E2%80%AFPM.png',
    'https://customer-assets.emergentagent.com/job_talent-intel/artifacts/hjduegv5_Screenshot%202025-11-26%20at%202.22.18%E2%80%AFPM.png',
  ];

  const templateImages = [
    'https://customer-assets.emergentagent.com/job_talent-iq-deploy/artifacts/cn1ukil6_jarvi-demo.jpg',
    'https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/tirker23_Screenshot%202025-10-30%20at%204.27.27%E2%80%AFPM.png',
    'https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/ypyx8by3_Screenshot%202025-10-30%20at%204.27.27%E2%80%AFPM.png',
    'https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/7qco2sw5_Screenshot%202025-10-30%20at%204.26.30%E2%80%AFPM.png',
    'https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/c7wwcvty_Screenshot%202025-10-30%20at%209.46.51%E2%80%AFPM.png',
    'https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/bvdzdj65_Screenshot%202025-10-30%20at%209.47.59%E2%80%AFPM.png',
    'https://customer-assets.emergentagent.com/job_d960481c-1f15-46de-bb72-a137cbe1286d/artifacts/2x76j2y1_image.png',
  ];

  const allImages = [...realImages, ...templateImages];

  // Create lanes
  const lanes = [];
  const imagesPerLane = Math.ceil(allImages.length / 4);

  for (let i = 0; i < 4; i++) {
    lanes.push(allImages.slice(i * imagesPerLane, (i + 1) * imagesPerLane));
  }

  const getDirectionClasses = () => {
    switch (direction) {
      case 'diagonal':
        return ['animate-float-diagonal-1', 'animate-float-diagonal-2', 'animate-float-diagonal-3', 'animate-float-diagonal-4'];
      case 'horizontal':
        return ['animate-scroll-left', 'animate-scroll-right', 'animate-scroll-left', 'animate-scroll-right'];
      default:
        return ['animate-float-diagonal-1', 'animate-float-diagonal-2', 'animate-float-diagonal-3', 'animate-float-diagonal-4'];
    }
  };

  const directionClasses = getDirectionClasses();

  return (
    <div className="absolute inset-0 overflow-hidden opacity-25 pointer-events-none">
      <div className="relative w-full h-full">
        {lanes.map((lane, laneIndex) => (
          <div
            key={laneIndex}
            className={`absolute flex gap-8 ${directionClasses[laneIndex]}`}
            style={{
              top: `${laneIndex * 25}%`,
              width: direction === 'horizontal' ? '200%' : 'auto',
            }}
          >
            {lane.concat(lane).map((img, imgIndex) => (
              <div
                key={imgIndex}
                className="flex-shrink-0 w-48 h-32 bg-cyan-500/10 rounded-lg overflow-hidden border border-cyan-500/20"
              >
                <img
                  src={img}
                  alt=""
                  className="w-full h-full object-cover opacity-50"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedBackgroundDirectional;
